/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopProductDto } from '../../models/shop-product-dto';
import { ShopProductUpdateDto } from '../../models/shop-product-update-dto';

export interface ShopProductControllerUpdate$Params {

/**
 * 상품 ID
 */
  id: string;
      body: ShopProductUpdateDto
}

export function shopProductControllerUpdate(http: HttpClient, rootUrl: string, params: ShopProductControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
  const rb = new RequestBuilder(rootUrl, shopProductControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopProductDto>;
    })
  );
}

shopProductControllerUpdate.PATH = '/api/shop-products/{id}';
